var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero",
    stroke: "#000",
    strokeWidth: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.39 10.403a2.89 2.89 0 1 0-2.89 2.907 2.901 2.901 0 0 0 2.89-2.907zm-4.735 0a1.845 1.845 0 1 1 1.845 1.861 1.856 1.856 0 0 1-1.845-1.86z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.723 24.53l-1.001-5.554a2.09 2.09 0 0 0-2.057-1.72h-4.122l1.362-1.83a7.214 7.214 0 0 0 1.471-4.772C22.126 6.93 19.078 4 15.435 4c-3.644 0-6.691 2.93-6.942 6.662a7.214 7.214 0 0 0 1.471 4.773l1.362 1.83H7.335a2.09 2.09 0 0 0-2.057 1.719L4.277 24.53A2.09 2.09 0 0 0 6.334 27h18.332a2.09 2.09 0 0 0 2.057-2.462v-.008zM9.536 10.733c.188-2.792 2.446-5.688 5.899-5.688 3.452 0 5.71 2.875 5.899 5.68a6.168 6.168 0 0 1-1.268 4.077l-4.631 6.205-4.64-6.197a6.168 6.168 0 0 1-1.26-4.077zm15.943 14.84c-.2.243-.498.383-.813.382H6.334a1.045 1.045 0 0 1-1.027-1.24l1-5.556c.09-.498.524-.86 1.03-.86h4.765l2.914 3.895a.523.523 0 0 0 .84 0l2.906-3.892h4.903c.504 0 .936.361 1.027.857l1.001 5.557c.055.304-.027.617-.225.854l.01.003z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.5e7aed0e7fa0941ea0711ef70fca7ce8.svg";
export { ForwardRef as ReactComponent };